import { render, staticRenderFns } from "./Forms.vue?vue&type=template&id=6241e631&"
import script from "./Forms.vue?vue&type=script&lang=js&"
export * from "./Forms.vue?vue&type=script&lang=js&"
import style0 from "./Forms.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports